import useWhatsappContact from '../../../../../hooks/useWhatsappContact';
import { useAuthContext } from '../../../AuthContext';

const useAuthContactButton = () => {
  const { loginContext } = useAuthContext();
  const { brandName, customerSupportPhone } = loginContext ?? {};

  return useWhatsappContact({ brandName, customerSupportPhone });
};

export default useAuthContactButton;
